import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import PropTypes from 'prop-types';
import React from 'react';

const Layout = ({ onSubmit }) => {
  const { resource } = useMetaLayoutContext();

  const handleChange = async (value) => {
    await onSubmit(value);
  };

  return (
    <MetaControlField
      key={'sort'}
      attr={'sort'}
      resource={resource}
      onChange={(value) => handleChange(value)}
      clearable={false}
    />
  );
};

Layout.defaultProps = {
  onSubmit: null,
};

Layout.propTypes = {
  onSubmit: PropTypes.func,
};

export default Layout;
